<template>
  <div class="_oa-chat-package-info">
    <h4 class="_section-title">
      OA Chat Package
    </h4>
    <p class="_section-content">
      แพ็กเกจเสริม ที่ช่วยให้คุณสามารถจัดการแชทอย่างมืออาชีพ มาพร้อมฟีเจอร์ที่มากกว่า เช่น แชทแท็ก การเพิ่มโน้ต และอื่นๆ พร้อมทั้งเก็บประวัติการแชทได้นานยิ่งขึ้น เพื่อให้การสื่อสารกับ ลูกค้าราบรื่นและมีประสิทธิภาพมากกว่าเดิม
    </p>
  </div>
</template>

<script>
export default {
  name: 'OaChatPackageInfo'
}
</script>

<style lang="scss" scoped>
._oa-chat-package-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: "Prompt", sans-serif;
}

._section-title {
  font-family: "Prompt", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.4;
  letter-spacing: 0%;
  color: #000000;
  margin: 0;
}

._section-content {
  font-family: "Prompt", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 0%;
  color: #666666;
  margin: 0;
}
</style>
